import { http } from "../../core/http";
import {
  downloadBlobResponse,
  handleBlobExportError,
} from "../../core/download";
import { normalizePaginatedResponse } from "../../core/response";
import type {
  AddFreightCostPayload,
  ConfirmImportFreightPayload,
  FreightCostTypeParams,
  UpdateFreightCostPayload,
} from "./types";

const getFreightVesion = async (params: Record<string, unknown>) => {
  const response = await http
    .get("admin/contractorFreight/version", { params })
    .then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const getAllFreight = async (params: Record<string, unknown>) => {
  const response = await http
    .get("admin/contractorFreight", { params })
    .then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const postAddFreightCost = async (
  payload: AddFreightCostPayload,
  params: FreightCostTypeParams,
) => {
  const response = await http
    .post("admin/contractorFreight", payload, { params })
    .then((res) => res.data);
  return response;
};

const putUpdateFreightCost = async (
  payload: UpdateFreightCostPayload,
  id: string,
  params: FreightCostTypeParams,
) => {
  const response = await http
    .put(`admin/contractorFreight/${id}`, payload, { params })
    .then((res) => res.data);
  return response;
};

export const postPreCheckImportFreight = async (file: Blob) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await http
    .post("/admin/contractorFreight/import/pre-check", formData)
    .then((res) => res.data);
  return response;
};

export const postConfirmImportFreight = async (
  payload: ConfirmImportFreightPayload,
) => {
  const response = await http.post(
    "/admin/contractorFreight/import/confirm",
    payload,
  );
  return response.data;
};

export const getExportVersion = async (id: string, name: string) => {
  try {
    const response = await http.get("/admin/contractorFreight/export", {
      params: { versionId: id },
      responseType: "blob",
      silent: true,
      silentLoading: true,
    });

    return downloadBlobResponse(response, `Cước doanh thu ${name}.xlsx`);
  } catch (error: unknown) {
    await handleBlobExportError(error);
    throw error;
  }
};

const shortDeleteFreightCost = async (payload: { ids: string[] }) => {
  const response = await http.put("/admin/contractorFreight/delete", payload);
  return response.data;
};

export const applyFreightCostVersionToOrders = async (versionId: string) => {
  const response = await http.post(
    `/admin/contractorFreight/version/${versionId}/apply-orders`,
  );
  return response.data;
};

export default {
  getFreightVesion,
  getAllFreight,
  postAddFreightCost,
  putUpdateFreightCost,
  postPreCheckImportFreight,
  postConfirmImportFreight,
  getExportVersion,
  shortDeleteFreightCost,
  applyFreightCostVersionToOrders,
};
